import JustValidate from 'just-validate'
import { DateRangePicker } from 'vanillajs-datepicker';
import Choices from "choices.js";
import { locationSuggestions } from "../search/locationSuggestions";
import { justValidateGlobalDefaults } from "../utils/justValidateDefaults";
import {loadingPopup, ajaxErrorPopUp, successToast} from "../utils/alerts";
import {authenticatedFetch} from "../utils/request";



function initRangePicker(id) {
    const rangepicker = new DateRangePicker(document.getElementById(id), {
        format: 'dd/mm/yyyy'
    });
    return rangepicker;
}

async function initCategories(id) {
    const el = document.getElementById(id);
    const request = await fetch(el.dataset.getCategories);
    const data = await request.json();
    const categories = new Choices(el, {
        removeItemButton: true,
        addItems: true
    });
    categories.setChoices(data, "text", "text", true);

    return categories;
}

function handleChoicesValidation(choicesInstance, validator) {
    let innerEl = choicesInstance.containerInner.element;
    validator.revalidateField('#Dto_Categories').then(isValid => {
        if (isValid) {
            innerEl.classList.remove("is-invalid");
            innerEl.classList.add("is-valid");
        }
        else {
            innerEl.classList.remove("is-valid");
            innerEl.classList.add("is-invalid");
        };
    });
}

function formEvents(form, validator, categoriesChoices) {
    document.getElementById("Dto_Categories").addEventListener("change", function (e) {
        handleChoicesValidation(categoriesChoices, validator);
    });
}

export async function reCaptchaCallback() {
    if (document.querySelector('#wantedItemForm button[type="submit"]')){
        const {form, validator} = await formValidation(document.getElementById("wantedItemForm"));
    }
    else {
        await initCategories("Dto_Categories")
    }
}

async function formValidation(form) {

    //Initialise the date range picker
    const dateRangePicker = initRangePicker("input-daterange");

    //Initialise the categories
    const categoriesChoices = await initCategories("Dto_Categories");

    const validator = new JustValidate(form, justValidateGlobalDefaults);

    validator
        .addField(document.querySelector('#Dto_ProductName'), [
            {
                rule: 'required',
                errorMessage: 'Please enter a title'
            }
        ])
        .addField(document.getElementById("Dto_Description"), [
            {
                rule: 'required',
                errorMessage: 'Please enter a description'
            }
        ])
        .addField(
            '#Dto_Categories',
            [
                {
                    rule: 'required',
                    errorMessage: 'Please select at least one category'
                }
            ],
            {
                errorsContainer: '#CategoriesErrorsContainer',
            }
        )
        .addField(document.querySelector('#Dto_FirstName'), [
            {
                rule: 'required',
                errorMessage: 'Please enter your name'
            }
        ])
        .addField(document.querySelector('#Dto_LastName'), [
            {
                rule: 'required',
                errorMessage: 'Please enter your last name'
            }
        ])
        .addField('#Dto_Email', [
            {
                rule: 'email',
                errorMessage: 'Please enter a valid email'
            },
            {
                rule: 'required',
                errorMessage: 'Please enter your email'
            }
        ])
        .addField(document.querySelector('#Dto_Price'), [
            {
                rule: 'number',
                errorMessage: 'Please enter a valid price'
            },
            {
                rule: 'minNumber',
                value: 0,
                errorMessage: 'Please enter a valid price'
            }
        ])
        .addField('#g-recaptcha-response', [
            {
                rule: 'required',
                errorMessage: 'Please solve the captcha challenge'
            }
        ], { errorsContainer: '#reCaptchaErrorsContainer'})
        .onSuccess(e => {
            handleChoicesValidation(categoriesChoices, validator);
            loadingPopup();
            form.submit();
        })
        .onFail(fields => handleChoicesValidation(categoriesChoices, validator));

    formEvents(form, validator, categoriesChoices);

    return { form, validator };
}

async function markFulfilled(el){
    const btn = el;
    btn.addEventListener("click", async function(e){
        e.preventDefault();
        const url = btn.dataset.url;
        let resp;
        if(btn.dataset.url.includes("admin")){
            resp = await authenticatedFetch(url, {
                method: "PATCH"
            });
        }
        else {
            resp = await fetch(url, {
                method: "PATCH"
            });
        }
        if(!resp.ok){
            ajaxErrorPopUp("Error marking wanted item as fulfilled");
            return false;
        }
        location.reload();
    });
}

document.addEventListener("DOMContentLoaded", async function (e) {
    window.reCaptchaCallback = reCaptchaCallback;
    const locationEl = document.getElementById("Dto_LocationName");
    await locationSuggestions(locationEl, locationEl.placeholder);
    
    const markFulfilledBtn = document.querySelector("#markFulfilled");
    const markRemovedBtn = document.querySelector("#markRemoved");
    if(markFulfilledBtn) {
        await markFulfilled(markFulfilledBtn);
    }

    if(markRemovedBtn)
    {
        await markFulfilled(markRemovedBtn);
    }
    
    //Form validation initialised by reCaptchaCallback

});